import { inject, injectable } from 'inversify'
import SERVICE_IDENTIFIER from '../../../framework/src/constants/identifiers'
import SystemConfig, {
	CONFIG_PARAMS,
} from '../../../framework/src/system/SystemConfig'
import { JokerBonusHelpers } from './helpers'

@injectable()
export class TranslateService {
	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig)
		protected systemConfig: SystemConfig
	) {}
	translations: { [key in TTranslateKeys]: string }
	async init(): Promise<void> {
		let lang = this.systemConfig.get(CONFIG_PARAMS.LANGUAGE) as string
		if (lang === 'cz') {
			lang = 'cs'
		}
		const data = await this.fetchTranslations(lang).catch(() =>
			this.fetchTranslations('EN')
		)
		this.translations = data
	}
	private async fetchTranslations(lang: string) {
		const url = `assets/JokerWinBanner/translations/${lang.toUpperCase()}.json`
		let response: Response
		for (let i = 0; i < 3; i++) {
			response = await fetch(JokerBonusHelpers.getUrl(url, this.systemConfig))
			if (response.ok) {
				const data = await response.json()
				return data
			}
			await new Promise((res) => {
				setTimeout(res, 350)
			})
		}
		throw new Error(`${response.statusText} (${response.url})`)
	}
	translate(key: TTranslateKeys) {
		return this.translations[key]
	}
}
export const TranslateKeys = {
	lastWin: 'last_win',
	highestWin: 'highest_win',
	winCount: 'win_count',
	popupText: 'popup_text',
	offline: 'offline',
} as const

export type TTranslateKeys = (typeof TranslateKeys)[keyof typeof TranslateKeys]
